/**
 * E-Prescriptions Feature
 *
 * Auto-registration and public exports for the e-prescriptions feature.
 * Enables electronic prescribing via DoseSpot integration.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { eprescriptionsFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(eprescriptionsFeature);

// Export store (all store-related exports)
export * from './store';

// Export components
export {
  DEANumberManagement,
  EpcsStatusCallout,
  EPrescriptionOrgSection,
  EPrescriptionOrgSetupModal,
  EPrescriptionPatientConnectModal,
  EPrescriptionUserSection,
  JotRxCompactCard,
  JotRxEncounterCta,
  JotRxPatientCard,
  JotRxSetupBanner,
  JotRxSetupCallout,
  JotRxSetupCard,
  MedicationHistoryBody,
  MedicationHistoryList,
  PatientPrescribeLauncher,
  PrescribingNotificationsBell,
} from './components';

// Export hooks
export { useConnectedPrescribers } from './hooks/useConnectedPrescribers';
export { useEpcsActivationWatcher } from './hooks/useEpcsActivationWatcher';
export { useJotRxEncounterAction } from './hooks/useJotRxEncounterAction';
export { useJotRxSetupState } from './hooks/useJotRxSetupState';
export { useOpenDoseSpot } from './hooks/useOpenDoseSpot';

// Export types
export * from './types';
